export type LgProgressProps = {
  /** 済んだ数 */
  value: number;
  /** 全部の数 */
  max: number;
  /** 読み上げの名前 (「導入・基礎の進み」など)。字の見出しが別にあっても付ける */
  label: string;
  /** 右に「済み 3」と数を出す。既定は出す */
  showCount?: boolean;
  /** 数に分母も付ける (「3/12」)。受講生の画面では付けない (代表の決まり)。講師や管理者が見る名簿だけが true */
  showTotal?: boolean;
  /** 単位 (「項目」「章」など)。数のあとに小さく付く */
  unit?: string;
  className?: string;
  /** 進みを描かず、全部の数だけを「43 項目」の形で出す (HP の見本。まだ受講生でない人に進みの印を見せない)。value は読まない */
  countOnly?: boolean;
  /** 線と分母を出さず「済み 3 項目」とだけ出す (本番の学習パス v2。分母は受講生の手と関係なく動くので見せない)。countOnly より先に効く */
  doneCountOnly?: boolean;
};

/** 細い線と数だけの進み。グラデーションも影も無い。全部済むと線が緑になる (緑は「済み」の役だけ) */
export function LgProgress({ value, max, label, showCount = true, showTotal = false, unit, className, countOnly = false, doneCountOnly = false }: LgProgressProps) {
  const total = Math.max(0, Number.isFinite(max) ? max : 0);
  if (doneCountOnly) {
    const doneN = Math.max(0, Number.isFinite(value) ? value : 0);
    return (
      <div className={`lg-progress lg-progress--count${className ? ` ${className}` : ""}`}>
        <span className="lg-progress__count lg-tnum lg-nowrap">
          済み {doneN}
          {unit ? <>{" "}<span className="lg-progress__unit">{unit}</span></> : null}
        </span>
      </div>
    );
  }
  if (countOnly) {
    return (
      <div className={`lg-progress lg-progress--count${className ? ` ${className}` : ""}`}>
        <span className="lg-progress__count lg-tnum lg-nowrap">
          {total}
          {unit ? <>{" "}<span className="lg-progress__unit">{unit}</span></> : null}
        </span>
      </div>
    );
  }
  const done = Math.min(Math.max(0, Number.isFinite(value) ? value : 0), total);
  const ratio = total > 0 ? done / total : 0;
  const complete = total > 0 && done >= total;
  return (
    <div className={`lg-progress${complete ? " lg-progress--done" : ""}${className ? ` ${className}` : ""}`}>
      <div
        className="lg-progress__track"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={done}
        aria-valuetext={showTotal ? `${done}/${total}${unit ? ` ${unit}` : ""}` : `済み ${done}${unit ? ` ${unit}` : ""}`}
      >
        <div className="lg-progress__fill" style={{ width: `${Math.round(ratio * 1000) / 10}%` }} />
      </div>
      {showCount ? (
        <span className="lg-progress__count lg-tnum lg-nowrap" aria-hidden="true">
          {showTotal ? `${done}/${total}` : `済み ${done}`}
          {unit ? <>{" "}<span className="lg-progress__unit">{unit}</span></> : null}
        </span>
      ) : null}
    </div>
  );
}
